import React from "react";
import CaruselGeneric from "../Generic/Carulal";
import {
  Container,
  Div,
  Text,
  Basic,
  Top,
  Bottom,
  Massage,
  Box,
  House,
  Calculate,
  Map,
} from "./styled";

const Card = () => {
  return (
    <React.Fragment>
      <Basic>
        <Container>
          <Div column>
            <Text size="30px">Why Choose Us</Text>
            <Text.Title size="18px" siz>
              We provide full service at every step
            </Text.Title>
          </Div>
          <Div>
            <CaruselGeneric>
              <Top>
                <Box className="icon">
                  <Massage />
                </Box>
              </Top>
              <Bottom>
                <Text>Trusted By Thousands</Text>
                <Text.Title>
                  With over 1 million+ homes for sale available on the website,
                  Trulia can match you with a house you will want to call home.
                </Text.Title>
              </Bottom>
            </CaruselGeneric>
            <CaruselGeneric>
              <Top>
                <Box className="icon">
                  <House />
                </Box>
              </Top>
              <Bottom>
                <Text>Wide Renge Of Properties</Text>
                <Text.Title>
                  With over 1 million+ homes for sale available on the website,
                  Trulia can match you with a house you will want to call home.
                </Text.Title>
              </Bottom>
            </CaruselGeneric>
            <CaruselGeneric>
              <Top>
                <Box className="icon">
                  <Calculate />
                </Box>
              </Top>
              <Bottom>
                <Text>Financing Made Easy</Text>
                <Text.Title>
                  With over 1 million+ homes for sale available on the website,
                  Trulia can match you with a house you will want to call home.
                </Text.Title>
              </Bottom>
            </CaruselGeneric>
            <CaruselGeneric>
              <Top>
                <Box className="icon">
                  <Map />
                </Box>
              </Top>
              <Bottom>
                <Text>See Neighborhoods</Text>
                <Text.Title>
                  With over 1 million+ homes for sale available on the website,
                  Trulia can match you with a house you will want to call home.
                </Text.Title>
              </Bottom>
            </CaruselGeneric>
          </Div>
        </Container>
      </Basic>
    </React.Fragment>
  );
};

export default Card;
